<template>
  <v-card class="pa-2 px-4">
    <div class="pb-2">People You Might Know</div>
    <v-divider></v-divider>
    <div
      v-if="suggestedUsers.length == 0"
      class="d-flex align-center justify-centers py-3"
    >
      <small>No Match Found</small>
    </div>
    <ProfileUserCard
      v-else
      :item="suggestedUser"
      v-for="suggestedUser of suggestedUsers"
      :key="suggestedUser.id"
    />
  </v-card>
</template>

<script>
import ProfileUserCard from "../ProfileUserCard.vue";
export default {
  name: "PeopleYouMightKnow",
  components: { ProfileUserCard },
};
</script>

<style scoped>
</style>